class Configuration {
	baseurl = process.env.REACT_APP_BASE_URL;
}

export default Configuration;
